import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';
import './App.css';
import AnnouncementBar from './components/layout/AnnouncementBar';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Platform from './pages/Platform';
import SolutionsIndia from './pages/SolutionsIndia';
import SolutionsEurope from './pages/SolutionsEurope';
import About from './pages/About';
import Resources from './pages/Resources';
import Contact from './pages/Contact';

function ScrollToTop(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppShell(): React.ReactElement {
  return (
    <>
      <ScrollToTop />
      <AnnouncementBar />
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/platform" component={Platform} />
        <Route path="/solutions/india" component={SolutionsIndia} />
        <Route path="/solutions/europe" component={SolutionsEurope} />
        <Route path="/about" component={About} />
        <Route path="/resources" component={Resources} />
        <Route path="/contact" component={Contact} />
      </Switch>
      <Footer />
    </>
  );
}

export default function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
